import React from 'react';

import * as S from'./KycExpiryModal.styles';
import classNames from 'classnames';
import {Footer} from './../Reports/Footer'

const KycExpiryModal = ({
  data:{header,body,footer},
  footerCb
}) => {
  
    return (

        <S.Container>
            <div  className='kycExpMdl'>
            {
                header?.primaryText &&
                <div className='kycExpMdl__hdr'>
                  <span className={classNames('mr12',header?.icon?.iconClasses)} />
                    <span className='font26 latoBlack blackText'>{header?.primaryText}</span>
                </div>
            }
            {
                header.secondaryText &&
                <div className={classNames('kycExpMdl__info',header?.style?.customClasses)}>
                    {header?.secondaryText}
                </div>
            }
            {body?.primaryText && <p className='font18 mb10'>{body?.primaryText}</p>}
            {body?.secondaryText && <p className='kycExpMdl__desc' dangerouslySetInnerHTML={{ __html: body?.secondaryText }} />}
            {footer?.ctas && 
             <div className='kycExpMdl__ftr'>
            <Footer data={footer?.ctas} onClickCb={footerCb}></Footer>
            </div>
            }      
           
            </div>
        </S.Container>
    )
}

export default KycExpiryModal;